import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { site } from '../data/site';
const links = [{
  to: '/formations',
  label: 'Nos formations'
}, {
  to: '/notre-approche',
  label: 'Notre approche'
}, {
  to: '/qualiopi',
  label: 'Qualité & Qualiopi'
}, {
  to: '/accessibilite',
  label: 'Accessibilité'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-50 w-full border-b border-surface-line bg-white/95 backdrop-blur" data-id="element-108" data-mp="31d9zr0nu8zd0">
      <div className="mx-auto flex max-w-content items-center justify-between gap-6 px-5 py-3.5 lg:px-8" data-id="element-109" data-mp="36aijh5omxbgd">
        <Link to="/" className="shrink-0" aria-label={`${site.nom} — accueil`} data-id="element-110" data-mp="3bbzfams9i7q3">
          <img src={site.logo} alt={site.nom} className="h-8 w-auto lg:h-9" data-id="element-111" data-mp="3fcjdzushhjec" />
        </Link>

        <nav className="hidden items-center gap-0.5 xl:flex" aria-label="Navigation principale" data-id="element-112" data-mp="2wlm8ne6n24jw">
          {links.map(l => <NavLink key={l.to} to={l.to} className={({
          isActive
        }) => `whitespace-nowrap rounded-lg px-3 py-2 text-[15px] font-medium transition-colors duration-150 ease-out ${isActive ? 'bg-brand-50 text-brand-800' : 'text-ink-muted hover:bg-surface-soft hover:text-brand-800'}`} data-id="element-113" data-mp="2rnuiaoln6qht">
              {l.label}
            </NavLink>)}
        </nav>

        <div className="hidden items-center gap-3 xl:flex" data-id="element-114" data-mp="35j6ez1jcyr1d">
          <a href={`tel:${site.telephoneLien}`} className="inline-flex items-center gap-2 whitespace-nowrap text-[15px] font-semibold text-brand-800 transition-colors duration-150 ease-out hover:text-accent-600" data-id="element-115" data-mp="30lwqbo3smjel">
            <PhoneIcon size={16} aria-hidden data-id="element-116" data-mp="1rdtfg5nggh94" />
            {site.telephone}
          </a>
          <Link to="/contact" className="whitespace-nowrap rounded-lg bg-accent-500 px-4 py-2.5 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-accent-600" data-id="element-117" data-mp="1wco8e0f4zm6y">
            Demander un devis
          </Link>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-surface-line text-brand-800 xl:hidden" aria-expanded={open} aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} data-id="element-118" data-mp="1mki5hvncjkcz">
          {open ? <XIcon size={20} data-id="element-119" data-mp="13n77eedgawz4" /> : <MenuIcon size={20} data-id="element-120" data-mp="13os1k2vusdwg" />}
        </button>
      </div>

      {open && <div className="border-t border-surface-line bg-white xl:hidden" data-id="element-121" data-mp="2t2nezpbq8amw">
          <nav className="mx-auto flex max-w-content flex-col gap-1 px-5 py-4" aria-label="Navigation mobile" data-id="element-122" data-mp="2y204khtzfvt6">
            {links.map(l => <NavLink key={l.to} to={l.to} className={({
          isActive
        }) => `rounded-lg px-3 py-3 text-base font-medium ${isActive ? 'bg-brand-50 text-brand-800' : 'text-ink'}`} data-id="element-123" data-mp="mfg32kjcjlec">
                {l.label}
              </NavLink>)}
            <a href={`tel:${site.telephoneLien}`} className="mt-1 inline-flex items-center gap-2 rounded-lg px-3 py-3 text-base font-semibold text-brand-800" data-id="element-124" data-mp="154cw6l30c7uz">
              <PhoneIcon size={17} aria-hidden data-id="element-125" data-mp="1f3lozam4zgfr" />
              {site.telephone}
            </a>
            <Link to="/contact" className="mt-1 rounded-lg bg-accent-500 px-4 py-3 text-center text-base font-semibold text-white" data-id="element-126" data-mp="1a3z9euiu5o3s">
              Demander un devis
            </Link>
          </nav>
        </div>}
    </header>;
}